import { getSelectorRoot } from 'utils/selectors';

const getResultsDataRoot = getSelectorRoot('resultsData');

export const getResultsDate = getResultsDataRoot('date');
export const getResultsActiveDate = getResultsDataRoot('activeDate');
export const getResultsCompetition = getResultsDataRoot('competitionId');
export const getResultsTeam = getResultsDataRoot('teamId');
export const getResultsStatus = getResultsDataRoot('status');
export const getResultsCurrentStatus = getResultsDataRoot('currentStatus');
export const getResultsSport = getResultsDataRoot('sportId');
export const getResultsData = getResultsDataRoot('data');
export const getResultsDataLoading = getResultsDataRoot('dataLoading');
export const getResultsTrigger = getResultsDataRoot('trigger');
